import React from "react";
import {Login} from "../pages";
import {Switch, Route} from "react-router-dom";

const Auth = () => {
  return (
    <Switch>
      <Route component={Login} />
    </Switch>
  );
};

export default Auth;
